module.exports = __webpack_public_path__ + "img/3.d3f375e6.svg";